import {customFieldConstants} from "_constants";

const INITIAL_STATE = {
    messageCustomFields: [],
    listMessageCustomFieldsLoading: false,
    listMessageCustomFieldsError: '',
    // set when a reply was rejected for missing required custom fields, so the voter can fetch auto-added ones
    missingRequiredCustomFieldsDetected: false,

    customFields: [],
    listCustomFieldsLoading: false,
    listCustomFieldsError: '',

    fetchedCustomFields: [],
    fetchCustomFieldsLoading: false,
    fetchCustomFieldsError: '',

    customField: {},
    getCustomFieldsLoading: false,
    getCustomFieldsError: '',

    updatedCustomField: {},
    updateCustomFieldsLoading: false,
    updateCustomFieldsError: '',

    newCustomFields: {},
    createCustomFieldsLoading: false,
    createCustomFieldsError: '',

    deleteCustomFieldsLoading: false,
    deleteCustomFieldsError: '',

    selectedCustomField: {},
    selectedMsgDataSource: {},
};

export function customFieldReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case customFieldConstants.LIST_CUSTOM_FIELDS_FOR_MESSAGE_REQUEST:
            return {...state, listMessageCustomFieldsLoading: true, missingRequiredCustomFieldsDetected: false};
        case customFieldConstants.LIST_CUSTOM_FIELDS_FOR_MESSAGE_SUCCESS:
            return {...state, messageCustomFields: action.payload, listMessageCustomFieldsLoading: false};
        case customFieldConstants.LIST_CUSTOM_FIELDS_FOR_MESSAGE_FAILURE:
            return {...state, listMessageCustomFieldsError: action.error, listMessageCustomFieldsLoading: false};

        // unlike the initial load, a refresh keeps the current list shown until the new one arrives
        case customFieldConstants.REFRESH_CUSTOM_FIELDS_FOR_MESSAGE_REQUEST:
            return {...state, refreshingMessageCustomFields: true};
        case customFieldConstants.REFRESH_CUSTOM_FIELDS_FOR_MESSAGE_SUCCESS:
            return {...state, messageCustomFields: action.payload, refreshingMessageCustomFields: false};
        case customFieldConstants.REFRESH_CUSTOM_FIELDS_FOR_MESSAGE_FAILURE:
            return {...state, refreshingMessageCustomFields: false};

        case customFieldConstants.MISSING_REQUIRED_CUSTOM_FIELDS_DETECTED:
            return {...state, missingRequiredCustomFieldsDetected: true};

        case customFieldConstants.LIST_CUSTOM_FIELDS_REQUEST:
            return {...state, listCustomFieldsLoading: true};
        case customFieldConstants.LIST_CUSTOM_FIELDS_SUCCESS:
            return {...state, customFields: processCustomFields(state.customFields, action.payload), listCustomFieldsLoading: false};
        case customFieldConstants.LIST_CUSTOM_FIELDS_FAILURE:
            return {...state, listCustomFieldsError: action.error, listCustomFieldsLoading: false};

        case customFieldConstants.FETCH_CUSTOM_FIELDS_REQUEST:
            return {...state, fetchCustomFieldsLoading: true, selectedMsgDataSource: action.payload};
        case customFieldConstants.FETCH_CUSTOM_FIELDS_SUCCESS:
            return {...state,
                fetchedCustomFields: processFetchedCustomFieldsFromSource(
                    state.fetchedCustomFields,
                    state.selectedMsgDataSource,
                    action.payload
                ),
                fetchCustomFieldsLoading: false
            };
        case customFieldConstants.FETCH_CUSTOM_FIELDS_FAILURE:
            return {...state, fetchCustomFieldsError: action.error, fetchCustomFieldsLoading: false};

        case customFieldConstants.GET_CUSTOM_FIELD_REQUEST:
            return {...state, getCustomFieldsLoading: true};
        case customFieldConstants.GET_CUSTOM_FIELD_SUCCESS:
            return {...state, customField: action.payload, getCustomFieldsLoading: false};
        case customFieldConstants.GET_CUSTOM_FIELD_FAILURE:
            return {...state, getCustomFieldsError: action.error, getCustomFieldsLoading: false};

        case customFieldConstants.UPDATE_CUSTOM_FIELD_REQUEST:
            return {...state, updateCustomFieldsLoading: true, selectedCustomField: action.payload};
        case customFieldConstants.UPDATE_CUSTOM_FIELD_SUCCESS:
            return {...state, updatedCustomField: action.payload, updateCustomFieldsLoading: false};
        case customFieldConstants.UPDATE_CUSTOM_FIELD_FAILURE:
            return {...state, getCustomFieldsError: action.error, updateCustomFieldsLoading: false};

        case customFieldConstants.CREATE_CUSTOM_FIELD_REQUEST:
            return {...state, createCustomFieldsLoading: true, selectedMsgDataSource: action.payload};
        case customFieldConstants.CREATE_CUSTOM_FIELD_SUCCESS:
            return {...state, newCustomFields: action.payload, createCustomFieldsLoading: false};
        case customFieldConstants.CREATE_CUSTOM_FIELD_FAILURE:
            return {...state, createCustomFieldsError: action.error, createCustomFieldsLoading: false};

        case customFieldConstants.DELETE_CUSTOM_FIELD_REQUEST:
            return {...state, deleteCustomFieldsLoading: true, selectedCustomField: action.payload};
        case customFieldConstants.DELETE_CUSTOM_FIELD_SUCCESS:
            return {...state, deleteCustomFieldsLoading: false};
        case customFieldConstants.DELETE_CUSTOM_FIELD_FAILURE:
            return {...state, createCustomFieldsError: action.error, deleteCustomFieldsLoading: false};

        case customFieldConstants.CLEAR_CUSTOM_FIELDS:
            return {...state, customFields: {}, listCustomFieldsError: '', listCustomFieldsLoading: false};

        case customFieldConstants.REMOVE_CUSTOM_FIELD_FROM_STORE:
            const { id } = action.payload;
            return {
                ...state,
                customFields: removeCustomFieldById(state.customFields, id),
                listCustomFieldsError: '',
                listCustomFieldsLoading: false,
            };

        default:
            return state
    }
}

function processCustomFields(existingData, response) {
    const newResponses = response.customFields;
    if (!Array.isArray(newResponses)) {
        console.error("Invalid data: customFields is not an array", response);
        return existingData;
    }
    const dataMap = new Map();

    existingData.forEach(entry => {
        dataMap.set(entry.masDataSourceId, {
            masDataSourceId: entry.masDataSourceId,
            customFields: [...entry.customFields]
        });
    });

    newResponses.forEach(field => {
        const { msgDataSourceId, id, name, sourceId, active } = field;
        if (!dataMap.has(msgDataSourceId)) {
            dataMap.set(msgDataSourceId, {
                masDataSourceId: msgDataSourceId,
                customFields: []
            });
        }
        const customFieldsArray = dataMap.get(msgDataSourceId).customFields;
        if (!customFieldsArray.some(existingField => existingField.id === id)) {
            customFieldsArray.push({ id, name, sourceId, active });
        }
    });

    return Array.from(dataMap.values());
}

function processFetchedCustomFieldsFromSource(existingData, selectedMsgDataSource, response) {
    if (!selectedMsgDataSource || !response || !Array.isArray(response.customFields)) {
        console.log("No data found for customFields", { selectedMsgDataSource, response });
        return existingData;
    }

    const dataSourceId = selectedMsgDataSource.id;
    const dataMap = new Map();

    existingData.forEach(entry => {
        dataMap.set(entry.masDataSourceId, {
            masDataSourceId: entry.masDataSourceId,
            customFields: [...entry.customFields]
        });
    });

    if (!dataMap.has(dataSourceId)) {
        dataMap.set(dataSourceId, {
            masDataSourceId: dataSourceId,
            customFields: []
        });
    }

    const customFieldsArray = dataMap.get(dataSourceId).customFields;

    response.customFields.forEach(field => {
        const { id, name, required, active, customFieldOptions } = field;
        if (!customFieldsArray.some(existingField => existingField.id === id)) {
            const newField = {
                id,
                name,
                required,
                active
            };
            if (Array.isArray(customFieldOptions) && customFieldOptions.length > 0) {
                newField.customFieldOptions = customFieldOptions;
            }
            customFieldsArray.push(newField);
        }
    });

    return Array.from(dataMap.values());
}

function removeCustomFieldById (customFields, id) {
    return customFields
        .map(item => ({
            ...item,
            customFields: item.customFields.filter(field => field.id !== id)
        }))
        .filter(item => item.customFields.length > 0);
}
